import { useTranslations } from "../../contexts/Translation";
import Section from "../Section";
import { CalendarError, ErrorIcon } from "../Icons";
import Loader from "../Loader/Loader";
import Main from "../Main";
import styles from "./SystemMessage.module.css";

type SystemMessageProps = {
  message: string;
  isError?: boolean;
};

const SystemMessage = ({ message, isError = false }: SystemMessageProps) => {
  const t = useTranslations("systemMessages");

  return (
    <Main>
      <Section className={[styles.section, isError && styles.error].filter(Boolean).join(" ")}>
        {message === "loading" && <Loader />}
        {(message === "notFound" || message === "errorLogin") && <ErrorIcon width='200px' height='200px' />}
        {message === "surveyEnded" && <CalendarError width='200px' height='200px' />}
        {message === "alreadyResponded" && <CalendarError width='200px' height='200px' />}
        {["contactFormError", "invalidDomain"].includes(message) && <ErrorIcon width='200px' height='200px' />}
        <div className={styles.message}>{t(message)}</div>
      </Section>
    </Main>
  );
};

export default SystemMessage;
